/**
 * 문제 포럼 과목·범위(scope) 구조 단일 출처 (JCG-2105).
 *
 * 포럼 인덱스(`forum/jcg/page.tsx`)와 상세 셸 좌측 "전체 범위" 지도(`CategoryMap`)가 같은
 * 과목/범위 목록을 써야 하므로 여기로 단일화한다. URL 은 `/forum/jcg/<subject.slug>/<scope.key>/<id>`.
 *
 * scope.key 는 Firebase `problems` 의 `scope` 필드 값과 1:1 대응(쿼리·라우팅 키).
 * scope 추가/이동/분리 시 이 파일 + [`scope-catalog.md`](../../.claude/docs/scope-catalog.md) §2 표를 동시 갱신해야 한다.
 */
export interface ForumScope {
  /** Firebase `scope` 필드 값 = URL 세그먼트 */
  key: string;
  /** 표시용 한글 라벨 */
  name: string;
}

export interface ForumSubject {
  /** URL 세그먼트(subject) */
  slug: string;
  /** 표시용 한글 라벨 */
  name: string;
  scopes: ForumScope[];
}

export const FORUM_SUBJECTS: ForumSubject[] = [
  {
    slug: "db",
    name: "데이터베이스",
    scopes: [
      { key: "logicDBdesign", name: "논리 DB 설계" },
      { key: "physicalDBdesign", name: "물리 DB 설계" },
      { key: "transaction", name: "트랜잭션" },
    ],
  },
  {
    slug: "sw-dev",
    name: "소프트웨어 개발",
    scopes: [
      { key: "test", name: "테스트" },
      { key: "interface", name: "인터페이스" },
    ],
  },
  {
    slug: "sw-design",
    name: "소프트웨어 설계",
    scopes: [
      { key: "appDesign", name: "애플리케이션 설계" },
      { key: "uml", name: "UML" },
      { key: "ui", name: "UI" },
      { key: "methodology", name: "방법론" },
    ],
  },
  {
    slug: "network-os",
    name: "네트워크/OS",
    scopes: [
      { key: "memoryProcess", name: "메모리/프로세스" },
      { key: "ip", name: "IP" },
      { key: "network7Layer", name: "네트워크 7계층" },
      { key: "shellScript", name: "셸 스크립트" },
    ],
  },
  {
    slug: "security-newtech",
    name: "보안/신기술",
    scopes: [
      { key: "attackTypes", name: "공격 유형" },
      { key: "cryptographyAlgorithm", name: "암호화 알고리즘" },
      { key: "securityFeature", name: "보안 기능" },
      { key: "newTech", name: "신기술" },
    ],
  },
  {
    slug: "programming",
    name: "프로그래밍",
    scopes: [
      { key: "sql", name: "SQL" },
      { key: "java", name: "Java" },
      { key: "python", name: "Python" },
      { key: "c", name: "C" },
    ],
  },
];

/**
 * scope.key → 소속 subject.slug 역인덱스. CategoryMap 에서 현재 scope 의 과목을 자동 펼치는 데 쓴다.
 */
export const SCOPE_TO_SUBJECT_SLUG: Record<string, string> = Object.fromEntries(
  FORUM_SUBJECTS.flatMap((subject) =>
    subject.scopes.map((scope) => [scope.key, subject.slug]),
  ),
);
